import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TopClickNavComponent } from './top-click-nav/top-click-nav.component';
import { TopSecondaryNavComponent } from './top-secondary-nav/top-secondary-nav.component';
import { SideNavComponent } from './side-nav/side-nav.component';

@NgModule({
    declarations: [
        TopClickNavComponent,
        TopSecondaryNavComponent,
        SideNavComponent,
    ],
    imports: [RouterModule, CommonModule, FormsModule],
    exports: [TopClickNavComponent, TopSecondaryNavComponent, SideNavComponent],
})
export class NavigationModule {}
